import { Component } from '@angular/core';
import * as moment from 'moment';
@Component({
  selector: 'app-layout-footer',
  templateUrl: './footer.component.html',
    styles: [`footer {text-align: center}`]
})
export class FooterComponent {
  year: string = moment().format('Y');
}



// WEBPACK FOOTER //
// ./src/app/shared/layout/footer.component.ts